.levelsGroup {
  display: flex;
  gap: var(--mantine-spacing-md);

  &[data-full-width] {
    width: 100%;

    & > * {
      flex: 1;
    }
  }
}
